module.exports = __webpack_public_path__ + "2384bd5c7a28e1592b965bbda3350eda.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/vinix-owns.jpg
// module id = 2079
// module chunks = 0